<template>
  <f7-page id="account-help-support" name="tnc-page" @page:afterin="afterin">
    <f7-navbar class="view-mobile">
        <f7-nav-left class="back-button">
            <f7-link icon-f7="chevron_left" @click="navigateTo('back')" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right></f7-nav-right>
    </f7-navbar>
    <f7-block>
        <div class="col-70 text-align-left pt-sm mb-md">
          <div class="wandr-title-1">{{$t('general-text-help-support')}}</div>
        </div>

        <div id="help-support-container" class="display-flex align-items-center justify-content-center">
            <f7-searchbar search-container="" search-in="" placeholder="Search service" id="help-support-search-bar" class="mb-md d-none"></f7-searchbar>
            <div class="grid" style="">
                <!-- <f7-link id="square-menu-chat" @click="navigateTo('#')" class="">
                    <div><img :src="require('@/assets/img/icon/menu-icon-chat-circle.svg')"></div>
                    <div class="">{{$t('help-support-chat')}}</div>
                </f7-link> -->
                <f7-link id="square-menu-faq" @click="navigateTo('faq')" class="">
                    <div><img :src="require('@/assets/img/icon/menu-icon-faq-circle.svg')"></div>
                    <div class="">{{$t('help-support-faq')}}</div>
                </f7-link>
                <f7-link id="square-menu-privacy-policy" @click="navigateTo('privacy-policy')" class="">
                    <div><img :src="require('@/assets/img/icon/menu-icon-privacy-policy-circle.svg')"></div>
                    <div class="">{{$t('help-support-privacy-policy')}}</div>
                </f7-link>
                <f7-link id="square-menu-tnc" @click="navigateTo('tnc')" class="">
                    <div><img :src="require('@/assets/img/icon/menu-icon-tnc-circle.svg')"></div>
                    <div class="">{{$t('help-support-tnc')}}</div>
                </f7-link>
                <f7-link id="square-menu-contact-us" :href="zoholink" target='_blank' class="external">
                    <div><img :src="require('@/assets/img/icon/menu-icon-contact-us-circle.svg')"></div>
                    <div class="">{{$t('general-text-contact-us-2')}}</div>
                </f7-link>
            </div>
        </div>
    </f7-block>
  </f7-page>
</template>

<script>
  export default {
    data() {
      return {
        zoholink               : process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK,
      };
    },
    methods: {
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      navigateTo(page){
        if(page=='faq'){
          this.$f7router.navigate("/faq"                      , { transition: 'f7-push'});
        }else if(page == 'tnc'){
          this.$f7router.navigate("/terms-and-condition"      , { transition: 'f7-push'});
        }else if(page == 'privacy-policy'){
          this.$f7router.navigate("/privacy-policy"           , { transition: 'f7-push'});
        }else if(page == 'back'){
          this.$f7router.back({ transition: 'f7-push' });
        }
      }
    }
  }
</script>